import { Button } from '../../../../../components/button/button';
import { Divider } from '../../../../../components/divider/divider';
import { Label } from '../../../../../components/label/label';
import { Modal, ModalProps } from '../../../../../components/modal/modal';
import { Select } from '../../../../../components/select/select';
import { TextArea } from '../../../../../components/textarea/textarea';
import { TimePicker } from '../../../../../features/date-time/time-picker/time-picker';
import { MultiSelect } from '../../../../../features/multi-select/multi-select';
import { Scheduler } from '../../../../../features/scheduler/scheduler';
import { SchedulerType } from '../../../../../store/api/scheduler-api';
import s from './tasks-create-planner-modal.module.css';
import { useTasksCreatePlannerModal } from './use-tasks-create-planner-modal';

export const TasksCreatePlannerModal = (props: ModalProps & { scheduler?: SchedulerType }) => {
  const {
    t,
    task,
    handleCreate,
    setTask,
    groupedStaffsByTags,
    executors,
    branches,
    selectedBranch,
    handleUpdateSpecs,
    handleUpdateWeek,
    isLoading,
  } = useTasksCreatePlannerModal(props);

  return (
    <Modal
      {...props}
      className={s.feature}
      title={t(props.scheduler ? 'Редактирование планировщика' : 'Создание запланированных задач')}
    >
      <div className={s.container}>
        <Label className={s.item}>{t('Запланировать время')}</Label>
        <div className={s.item}>
          <TimePicker
            value={task.start_time}
            onChange={(e) => setTask({ ...task, start_time: e })}
            name="start_time"
            placeholder={t('Время')}
            data-testid="time-picker"
          />
        </div>
      </div>

      <div className={s.row}>
        <div className={s.inputs}>
          <TextArea
            name="name"
            value={task.title}
            onChange={(e) => setTask({ ...task, title: e.currentTarget.value })}
            placeholder={t('Опишите задачу')}
            data-testid="name-input"
            maxLength={200}
            style={{
              height: 160,
            }}
          />
          <Select
            name="branch"
            options={branches}
            value={selectedBranch}
            onSelect={(e) =>
              setTask({ ...task, place_id: Number(e.id), staff_ids: [], staff_id: undefined })
            }
            placeholder={t('Филиал')}
            data-testid="branch-input"
            withSearch
          />
          <MultiSelect
            name="executor"
            value={executors}
            onSelect={(e) => setTask({ ...task, staff_ids: e.map((item) => Number(item.id)) })}
            options={groupedStaffsByTags}
            placeholder={t('Ответственные')}
            data-testid="responsibles-input"
          />
        </div>

        <Scheduler
          {...task}
          handleUpdateSpecs={handleUpdateSpecs}
          handleUpdateWeek={handleUpdateWeek}
          handleUpdateTime={(e) => setTask({ ...task, start_time: e })}
        />
      </div>

      <Divider />

      <div className={s.controls}>
        <Button
          variant="secondary"
          onClick={props.onClose}
          disabled={isLoading}
          data-testid="back-button"
        >
          {t('Назад')}
        </Button>
        <Button
          variant="primary"
          onClick={handleCreate}
          disabled={isLoading}
          data-testid="submit-button"
        >
          {t(props.scheduler ? 'Изменить' : 'Создать')}
        </Button>
      </div>
    </Modal>
  );
};
